"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.logBusinessEventError = logBusinessEventError;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _AjaxObservable = require("rxjs/observable/dom/AjaxObservable");

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var _ISS = require("./ISS");

var _Telemetry = require("./Telemetry");

function logBusinessEventError(type, error, eventProperties) {
  var telemetryProvider = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _Telemetry.telemetry;
  var customTelemetry = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');

  if (eventProperties === undefined) {
    eventProperties = new _Telemetry.EventProperties();
    eventProperties.setProperty(_ISS.IssPropertyName.Action_OperationName, type);
  }

  var messages = [error.message];

  if (error.stack) {
    messages.push(error.stack);
  }

  if (error instanceof _AjaxObservable.AjaxError) {
    var _eventProperties;

    if (error.request.url !== undefined) {
      messages.push(error.request.url);
    }

    messages.push(error.status.toString());
    messages.push(error.xhr.statusText);
    (_eventProperties = eventProperties) === null || _eventProperties === void 0 ? void 0 : _eventProperties.setProperty(_ISS.IssPropertyName.Result_FailureType, _ISS.IssFailureType.ServiceError);
  } else {
    var _eventProperties2;

    (_eventProperties2 = eventProperties) === null || _eventProperties2 === void 0 ? void 0 : _eventProperties2.setProperty(_ISS.IssPropertyName.Result_FailureType, _ISS.IssFailureType.NotSpecified);
  }

  if (customTelemetry === null || customTelemetry === void 0 ? void 0 : customTelemetry.error) {
    customTelemetry.error(type, (0, _objectSpread2.default)({
      message: messages.join('|')
    }, eventProperties));
  } else {
    telemetryProvider.logFailure(error.name, messages.join('|'), error.message, type, eventProperties);
  }
}